import { Injectable } from '@angular/core';

export interface FileInformation {
  path?: string;
  name: string;
  mimeType: string;
}

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor() {}

  async savePdf(dataBase64: string, fileName: string): Promise<FileInformation> {
    const docPdf = `data:application/pdf;base64,${dataBase64}`;

    return await this.save(docPdf, fileName);
  }

  async save(data: string, fileName: string): Promise<FileInformation> {
    const blob = await this.getBlobFromUrl(data);

    const mimeType = data.replace(/^data:([^;,]*)[,;].*$/g, '$1').trim();

    return await this.saveInBrowser(blob, fileName, mimeType);
  }

  private async getBlobFromUrl(url: string): Promise<Blob> {
    const response = await fetch(url);
    return await response.blob();
  }

  private async saveInBrowser(
    data: Blob,
    fileName: string,
    mimeType: string
  ): Promise<FileInformation> {
    const fileUrl = URL.createObjectURL(data);

    const placeholder = document.createElement('a');
    placeholder.href = fileUrl;
    placeholder.setAttribute('download', fileName);
    placeholder.click();

    return {
      name: fileName,
      mimeType,
    };
  }
}
